export const Constants = {
    ATTRIBUTES: {
        EDITOR_ID: 'data-editor-id',
        LOCATION_ID: 'data-velt-location-id',
    },
    ELEMENT_TYPE: {
        VELT_COMMENT: 'veltComment',
    },
};
